import resolveResponse from 'contentful-resolve-response'
import fetchQueryWrapper from '../network/fetchQueryWrapper'
import { getCollectionParams } from '../network/queryParams'
import logger from '../utils/winston-logger/winston-logger'
import extractStoryCollection from '../data/transformers/extractStoryCollection'
import CategoryDetails from '../components/Category/CategoryDetails'

const Latest = ({ collection }) => <CategoryDetails category={{ title: 'Latest' }} collection={collection} />

export async function getServerSideProps() {
  try {
    const storyCollection = await fetchQueryWrapper(getCollectionParams({}), resolveResponse)

    return { props: { collection: extractStoryCollection(storyCollection) } }
  } catch (error) {
    logger.error('Error in latest.page.js ', error)
    return { notFound: true }
  }
}

export default Latest
